const SvgIconArrow = (props) => {
  const {
    width = 24,
    height = 24,
    enableViewBox = true,
    iconFillColor = "#FFF",
    outerFillColor = "none",
    onClick,
    ...otherProps
  } = props;

  return (
    <svg
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      {...otherProps}
    >
      <g fill={outerFillColor} fillRule="evenodd">
        <path d="M2 2h20v20H2z" />
        <path
          d="M10.646 4.164l.897-.92a.948.948 0 011.369 0l7.85 8.052c.38.39.38 1.019 0 1.404l-7.85 8.055a.948.948 0 01-1.37 0l-.896-.92a1.014 1.014 0 01.016-1.42l4.867-4.758H3.922a.98.98 0 01-.97-.994v-1.326a.98.98 0 01.97-.994h11.607l-4.867-4.757a1.006 1.006 0 01-.016-1.422z"
          fill={iconFillColor}
          onClick={onClick}
        />
      </g>
    </svg>
  );
};

export default SvgIconArrow;
